import { render } from "./detallesPonenetePrincipal.vue?vue&type=template&id=c3065bcc"
import script from "./detallesPonenetePrincipal.vue?vue&type=script&lang=js"
export * from "./detallesPonenetePrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__